import { Role } from "@cryptors/api-client";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { usePermissions } from "@refinedev/core";
import { DeleteButton } from "@refinedev/mui";
import type { DeleteButtonProps } from "@refinedev/mui";
import { FC, useState } from "react";

// Wraps Refine's DeleteButton. For a REDACTEUR (who may not delete) it renders
// a trash icon that opens an explicit "deletion impossible" modal instead of
// attempting the delete (which the backend would 403 anyway). Every other role
// gets the normal access-controlled DeleteButton.
const DeleteGuardButton: FC<DeleteButtonProps> = (props) => {
  const { data: role } = usePermissions<Role>({});
  const [open, setOpen] = useState(false);

  if (role !== Role.REDACTEUR) {
    return <DeleteButton {...props} />;
  }

  return (
    <>
      <IconButton
        color="error"
        size="small"
        aria-label="delete"
        onClick={() => setOpen(true)}
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Suppression impossible</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Votre rôle (Rédacteur) ne permet pas de supprimer cet élément.
            Contactez un administrateur si besoin.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} autoFocus>
            Compris
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteGuardButton;
